// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".translatable-field:not(:last-child) .field-wrapper[data-v-7983404e]{border-style:solid!important}", "",{"version":3,"sources":["webpack://./app/fields/Translatable/js/fields/Form/TranslatableField.vue"],"names":[],"mappings":"AAEE,qEACE,4BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
